import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
const {FiAlertTriangle,FiHome,FiPackage,FiUsers,FiRadio,FiNavigation,FiDroplet,FiShield}=FiIcons;
const EmergencyPreparedness=()=> {
const emergencyKits=[
{title: 'Water',description: '1 gallon per person per day for 3 days',icon: FiDroplet,quantity: '3-day supply'},
{title: 'Food',description: 'Non-perishable, easy-to-prepare items',icon: FiPackage,quantity: '3-day supply'},
{title: 'First Aid',description: 'Bandages, medications, medical supplies',icon: FiShield,quantity: 'Complete kit'},
{title: 'Communication',description: 'Battery-powered radio, whistles, cell phone chargers',icon: FiRadio,quantity: 'Multiple devices'},
{title: 'Tools',description: 'Flashlights, multi-tools, wrenches',icon: FiNavigation,quantity: 'Basic set'},
{title: 'Documents',description: 'Important papers, cash, emergency contacts',icon: FiUsers,quantity: 'Waterproof container'},
];
const disasterTypes=[
{type: 'Earthquake',preparation: 'Drop, Cover, and Hold On. Secure heavy furniture. Identify safe spots in each room.',evacuation: 'Move to open areas away from buildings, power lines, and trees. Avoid bridges and overpasses.',icon: '🌍'},
{type: 'Volcanic Eruption',preparation: 'Know evacuation routes. Prepare face masks and goggles. Store water in sealed containers.',evacuation: 'Follow official evacuation orders. Move upwind from ash fall. Avoid low-lying areas.',icon: '🌋'},
{type: 'Tsunami',preparation: 'Know evacuation zones and routes. Practice evacuation drills. Prepare emergency supplies.',evacuation: 'Move to higher ground immediately if you feel strong earthquake or see unusual ocean behavior.',icon: '🌊'},
{type: 'Flood',preparation: 'Elevate utilities. Install sump pumps. Keep important documents in waterproof containers.',evacuation: 'Move to higher ground before water rises. Avoid walking or driving through flood waters.',icon: '🌧️'},
{type: 'Typhoon',preparation: 'Reinforce windows. Clear gutters and drains. Trim trees near your home.',evacuation: 'Follow official evacuation orders. Stay indoors away from windows during the storm.',icon: '🌀'},
];
return (
<motion.section initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} className="bg-white rounded-lg shadow-md p-6 mb-6" >
<div className="mb-8">
<h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center space-x-2">
<SafeIcon icon={FiAlertTriangle} className="text-red-600" />
<span>Emergency Preparedness Guide</span>
</h2>
<p className="text-gray-600 leading-relaxed mb-6">
Being prepared can save lives during natural disasters. The Philippines is prone to various hazards, and having a solid emergency plan and preparedness kit is essential for every household and community.
</p>
</div>
<div className="mb-8">
<h3 className="text-xl font-semibold text-gray-900 mb-6">Emergency Kit Essentials</h3>
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
{emergencyKits.map((item,index)=> (
<motion.div key={item.title} initial={{opacity: 0,y: 10}} animate={{opacity: 1,y: 0}} transition={{delay: index * 0.1}} className="bg-gray-50 rounded-lg p-4 border border-gray-200" >
<div className="flex items-center space-x-3 mb-2">
<SafeIcon icon={item.icon} className="text-blue-600 text-lg" />
<div>
<h4 className="font-semibold text-gray-900">{item.title}</h4>
<span className="text-xs text-gray-500 bg-gray-200 px-2 py-1 rounded-full">{item.quantity}</span>
</div>
</div>
<p className="text-sm text-gray-600">{item.description}</p>
</motion.div>
))}
</div>
</div>
<div className="mb-8">
<h3 className="text-xl font-semibold text-gray-900 mb-6">Disaster-Specific Guidelines</h3>
<div className="space-y-6">
{disasterTypes.map((disaster,index)=> (
<motion.div key={disaster.type} initial={{opacity: 0,x: -10}} animate={{opacity: 1,x: 0}} transition={{delay: index * 0.1}} className="border border-gray-200 rounded-lg p-5" >
<div className="flex items-start space-x-4">
<span className="text-3xl">{disaster.icon}</span>
<div className="flex-1">
<h4 className="font-semibold text-gray-900 mb-3">{disaster.type}</h4>
<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
<div>
<h5 className="font-medium text-gray-800 mb-2 flex items-center space-x-2">
<SafeIcon icon={FiHome} className="text-sm" />
<span>Preparation</span>
</h5>
<p className="text-sm text-gray-600">{disaster.preparation}</p>
</div>
<div>
<h5 className="font-medium text-gray-800 mb-2 flex items-center space-x-2">
<SafeIcon icon={FiNavigation} className="text-sm" />
<span>Evacuation</span>
</h5>
<p className="text-sm text-gray-600">{disaster.evacuation}</p>
</div>
</div>
</div>
</div>
</motion.div>
))}
</div>
</div>
<div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
<div className="flex items-start space-x-2">
<SafeIcon icon={FiAlertTriangle} className="text-amber-600 text-sm mt-0.5 flex-shrink-0" />
<div className="text-sm text-amber-800">
<strong>Family Emergency Plan:</strong> Create a communication plan with family members. Know evacuation routes in your area. Designate meeting points. Keep important documents and emergency contacts readily accessible. Practice your plan regularly.
</div>
</div>
</div>
<div className="bg-red-50 border border-red-200 rounded-lg p-4">
<div className="flex items-start space-x-2">
<SafeIcon icon={FiAlertTriangle} className="text-red-600 text-sm mt-0.5 flex-shrink-0" />
<div className="text-sm text-red-800">
<strong>During Emergencies:</strong> Stay informed through official channels like PAGASA and PHIVOLCS. Follow evacuation orders immediately. Help neighbors who may need assistance. Keep emergency supplies accessible. Stay calm and follow your emergency plan.
</div>
</div>
</div>
</motion.section>
);
};
export default EmergencyPreparedness;